import { render, staticRenderFns } from "./Doses.vue?vue&type=template&id=6947d738&"
import script from "./Doses.vue?vue&type=script&lang=js&"
export * from "./Doses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports